module.exports = __webpack_public_path__ + "media/images/Profile-Pro-fb6e4cf7e96f7d74965c16650e5e9558.svg";